<script lang="ts">
  import { Container, Image } from 'sveltestrap';
  import { WEARECOMINGSOON } from '../../../../utils/Constant/Constant';
  import CountDown from "../../../Core/CountDown.svelte";
  let imgPath:string = "/assets/images/logo"
</script>
  
<div class="page-wrapper compact-wrapper" id="pageWrapper">
  <Container fluid class="p-0">
    <div class="comingsoon auth-bg-video">
      <video class="bgvideo-comingsoon" id="bgvid" poster="/assets/images/other-images/coming-soon-bg.jpg" playsinline autoplay muted loop >
        <source src="/assets/video/auth-bg.mp4" type="video/mp4"/> 
      </video>
      <div class="comingsoon-inner text-center">
        <Image src="{imgPath}/logo-1.png" />
        <h5>{WEARECOMINGSOON}</h5>
        <div>
          <CountDown />
        </div>
      </div>
    </div>
  </Container>
</div>
  